/* unplugin-vue-components disabled */import { render } from "./tenant.vue?vue&type=template&id=12c7b25b&scoped=true"
import script from "./tenant.vue?vue&type=script&setup=true&lang=js"
export * from "./tenant.vue?vue&type=script&setup=true&lang=js"

import "./tenant.vue?vue&type=style&index=0&id=12c7b25b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c7b25b"],['__file',"src/pages/tenant/tenant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12c7b25b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12c7b25b', __exports__)) {
    api.reload('12c7b25b', __exports__)
  }
  
  module.hot.accept("./tenant.vue?vue&type=template&id=12c7b25b&scoped=true", () => {
    api.rerender('12c7b25b', render)
  })

}


export default __exports__